import apiFetch from "@/src/utils/apiFetch";

import { closeDrawer, openDrawer } from "@/src/components/dialogs";

import { Button } from "@/src/components/buttons";
import { Card, CompartmentCard, ReferenceCard } from "@/src/components/cards";
import {
  FetchableList,
  ListConstructor,
} from "@/src/components/fetchableLists";
import { Input } from "@/src/components/universalInput";
import { Patient, RefAnswer, Reference } from "@/src/data/allTypes";
import { USER } from "@/src/data/globalVariables";
import {
  checkReferenceGuidelines,
  getUserId,
  getUserShortName,
  jsonAbstract,
  uid,
  updateOrPush,
} from "@/src/utils/utils";
import { useState } from "react";
import { FieldAnswersList } from "../fields/fieldsAnswersList";
import { RefAnswerForm } from "../fields/referenceFieldsForm";
import { openSnomedConceptPicker } from "../snomed/SnomedConceptPicker";
import { openReferenceGuidelinesDialog } from "../admin/referentiel/referenceGuidelinesDialog";

function MotiveCompartment({
  patient,
  current,
  onChange,
}: {
  patient: Patient;
  current: (RefAnswer | null | undefined)[];
  onChange: (newValue: (RefAnswer | null | undefined)[]) => void;
}) {
  const [reload, setReload] = useState(0);
  let [refAnswers, setRefAnswers] = useState<(RefAnswer | null | undefined)[]>(
    current || []
  );

  function addToRefAnswers(refAnswer: RefAnswer) {
    updateOrPush(
      refAnswers,
      refAnswer,
      (item) => item?.reference?.id === refAnswer?.reference?.id
    );

    let newResults = [...(refAnswers || [])];
    setRefAnswers(newResults);
    onChange(newResults);
  }

  function removeFromRefAnswers(refAnswer: RefAnswer) {
    refAnswers = refAnswers || [];
    refAnswers = refAnswers.filter(
      (item) => item?.reference?.id !== refAnswer.reference?.id
    );
    setRefAnswers([...refAnswers]);
    onChange(refAnswers);
  }

  return (
    <CompartmentCard
      title="Motif(s)"
      onClick={async () => {
        await openSnomedConceptPicker({
          title: "Choisir un motif",
          // parentIds: ["disease", "finding"],
          category: "motive",
          onSelect: async (reference) => {
            let refAnswer: RefAnswer = {
              patient,
              reference: reference,
              creator: USER.get(),
              fieldAnswers: [],
            };

            await openDrawer({
              id: "referenceFieldsDrawer",
              title: `Ajouter Motif`,
              additionalClasses: ["medium"],
              content: (
                <RefAnswerForm
                  patient={patient}
                  refAnswer={refAnswer}
                  onChange={(newPatientsReference) => {
                    refAnswer = newPatientsReference;
                  }}
                ></RefAnswerForm>
              ),
              onConfirm: async () => {
                addToRefAnswers(refAnswer);
                closeDrawer("motivesListDrawer");
              },
            });
          },
        });

        // await openDrawer({
        //   id: "motivesListDrawer",
        //   title: "Choisir un motif",
        //   additionalClasses: ["medium"],
        //   content: (
        //     <MotivesList
        //       onSelect={async (reference) => {
        //         let refAnswer: RefAnswer = {
        //           patient,
        //           reference: reference,
        //           creator: USER.get(),
        //           fieldAnswers: [],
        //         };

        //         await openDrawer({
        //           id: "referenceFieldsDrawer",
        //           title: `Ajouter Motif`,
        //           additionalClasses: ["medium"],
        //           content: (
        //             <RefAnswerForm
        //               patient={patient}
        //               refAnswer={refAnswer}
        //               onChange={(newPatientsReference) => {
        //                 refAnswer = newPatientsReference;
        //               }}
        //             ></RefAnswerForm>
        //           ),
        //           onConfirm: async () => {
        //             addToRefAnswers(refAnswer);
        //             closeDrawer("motivesListDrawer");
        //           },
        //         });
        //       }}
        //     ></MotivesList>
        //   ),
        // });
      }}
    >
      <ListConstructor
        data={refAnswers}
        isLoading={false}
        isError={false}
        error={null}
        emptyChild={<div className="gray center p10">Aucun motif ajouté</div>}
      >
        <div className="c1 gap10">
          {refAnswers?.map((refAnswer, index) => {
            if (!refAnswer) return;
            return (
              <Card
                key={uid()}
                color="blue"
                animationIndex={index}
                title={
                  <div className="capitalize">{refAnswer?.reference?.name}</div>
                }
                subTitle={getUserShortName(refAnswer?.creator)}
                leading={<></>}
                // className="card"
                onClick={async () => {
                  console.log({ refAnswer });

                  let newRefAnswer: RefAnswer = jsonAbstract(refAnswer);

                  await openDrawer({
                    id: "referenceFieldsDrawer",
                    title: `Ajouter motif`,
                    content: (
                      <RefAnswerForm
                        patient={patient}
                        refAnswer={newRefAnswer}
                        onChange={(newPatientsReference) => {
                          newRefAnswer = newPatientsReference;
                        }}
                      ></RefAnswerForm>
                    ),
                    onConfirm: async () => {
                      addToRefAnswers(newRefAnswer);
                      closeDrawer("motivesListDrawer");
                    },
                  });
                }}
                onDelete={() => {
                  removeFromRefAnswers(refAnswer);
                }}
              >
                <div className="c1 gap10 mtop10">
                  <FieldAnswersList
                    patient={patient}
                    reference={refAnswer.reference}
                    answers={refAnswer?.fieldAnswers || []}
                  ></FieldAnswersList>
                </div>
                <div className="gray"> {refAnswer?.notes} </div>
              </Card>
            );
          })}
        </div>
      </ListConstructor>
    </CompartmentCard>
  );
}

function getCim10Elements(searchKey: string, limit: number): Reference[] {
  return [];
  // if (limit <= 0) return [];
  // if (!searchKey) return [];
  // let result: Reference[] = [];
  // for (let item of Object.values((cim10 || {}) as any)) {
  //   // item= item as any;
  //   // if (!item) continue;
  //   // if (!item.name.toLowerCase().includes(searchKey.toLowerCase())) continue;
  //   // if (result.length >= limit) break;
  //   // result.push({
  //   //   id: item.code,
  //   //   name: item.name,
  //   //   cim11Code: item.code,
  //   //   category: "motive",
  //   // });
  // }

  // return result;
}

function MotivesList({
  onSelect,
}: {
  onSelect: (reference: Reference) => void;
}) {
  const [reload, setReload] = useState(0);
  let [searchKey, setSearchKey] = useState("");

  return (
    <div className="grid c1 gap10">
      <FetchableList
        queryKey={["MotivesList", searchKey, reload]}
        queryFn={() =>
          apiFetch(
            "references",
            "loadMany",
            {
              userId: getUserId(),

              categoriesIds: ["motive"],
              searchKey,
            },
            "Erreur lors du chargement des motifs"
          )
        }
        searchKey={searchKey}
        onSearch={(newValue) => {
          setSearchKey(newValue || "");
        }}
        onClick={async () => {
          let reference: Reference = {
            name: searchKey,
            category: "motive",
            creator: getUserId(),
            usageCount: 0,
          };

          await openDrawer({
            id: "referenceFormDrawer",
            title: "Nouveau motif",
            content: (
              <Input
                name={"Nom"}
                type="text"
                value={reference.name}
                onChange={(newValue) => {
                  reference.name = newValue;
                }}
              ></Input>
            ),
            onConfirm: async () => {
              if (!checkReferenceGuidelines(reference)) {
                openReferenceGuidelinesDialog();
                return false;
              }

              let lastInserted = await apiFetch(
                "references",
                "addOne",
                {
                  reference,
                },
                "Erreur lors de la création du motif"
              );
              setReload((prev) => prev + 1);
            },
          });
        }}
        emptyChild={
          <div className="grid c1 gap10">
            <div className="gray p20 center">
              Aucun motif trouvé
              <strong>{searchKey && `content ${searchKey}`}</strong>
            </div>
            {searchKey && (
              <Button
                onClick={async () => {
                  let reference: Reference = {
                    name: searchKey,
                    category: "motive",
                    creator: getUserId(),
                    usageCount: 0,
                  };

                  if (!checkReferenceGuidelines(reference)) {
                    openReferenceGuidelinesDialog();
                    return false;
                  }
                  let lastInserted = await apiFetch(
                    "references",
                    "addOne",
                    {
                      reference,
                    },
                    "Erreur lors de la création du motif"
                  );
                  setReload((prev) => prev + 1);
                }}
              >
                Créer le motif {searchKey}
              </Button>
            )}
          </div>
        }
      >
        {(data) => (
          <div className="grid c1 gap10">
            {searchKey == "" && (
              <div className="gray">Motifs les plus fréquents</div>
            )}
            {data?.map((reference) => {
              return (
                <ReferenceCard
                  key={uid()}
                  searchKey={searchKey}
                  reference={reference}
                  onClick={() => {
                    onSelect(reference);
                  }}
                />
              );
            })}
          </div>
        )}
      </FetchableList>
    </div>
  );
}

export { MotiveCompartment };
